import styled from 'styled-components';

const BORDER_STYLE = `solid 1px ${Styles.color.grey.five}`;
const ARIA_EXPANDED = 'aria-expanded';

export const SelectionOptionsHeader = styled.div<{ [ARIA_EXPANDED]: boolean }>`
  border-bottom: ${p => (p[ARIA_EXPANDED] ? 'none' : BORDER_STYLE)};
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  padding-right: calc(1rem + 5px);
  padding-top: 1rem;
  padding-bottom: ${p => (p[ARIA_EXPANDED] ? '0' : '1rem')};
  padding-left: 1rem;
`;
